<div class="checkout-options" [ngClass]="{ 'modalarab': dir === true }">
  <div class="modal-header">
    <h5 class="modal-title" id="myModalLabel160">{{ 'Global.rp' | translate}}</h5>
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0" ngbAutofocus>
    <div class="price-details text-center">
      <h6 class="price-title" id="nomService">{{ nomService }}</h6>
      <br />
      <ul class="list-unstyled">
        <div *ngFor="let item of dataService">
          <li *ngIf="item.key != 'Etiquette' else etq" class="price-detail" [ngStyle]="{ color: item.color ? item.color : null }">
            <div class="detail-title key" [ngClass]="{ 'text-primary': !item.color }">
              <strong>{{ item.key }}</strong>
            </div>
            <div  class="detail-amt">{{ item.value }}</div>
          </li>
          <ng-template #etq>
            <ng-container>
              <div class="detail-title key" [ngClass]="{ 'text-primary': !item.color }">
                <strong>{{ item.key }}</strong>
              </div>
              <br>
              <div>{{ item.value }}</div>
            </ng-container>
          </ng-template>
          <hr />
        </div>
      </ul>
      <img src="assets/images/logo/logo.png" alt="Logo" />
      <div>{{ 'Global.merci' | translate}}</div>
    </div>
  </div>
</div>
